<script setup lang="ts">
import AppToasterBridge from '@/components/AppToasterBridge.vue';
</script>

<template>
  <UApp :toaster="{ position: 'bottom-center', expand: true, duration: 3000 }">
    <!-- Bridges toasts fired outside setup context (axios interceptors) -->
    <AppToasterBridge />
    <RouterView />
  </UApp>
</template>
